import { put, takeLatest } from 'redux-saga/effects';
import { orderBy, forEach, indexOf, every } from 'lodash';
import helpers from 'utils/helpers';
import countriesData from 'data/countries';
import categoriesData from 'data/categories';
import areasData from 'data/areas';
const { rp } = helpers;

const SET_REDUX_STATE = 'SET_REDUX_STATE';

const GET_QUOTATION_REQUEST = 'GET_QUOTATION_REQUEST';
const GET_QUOTATION_SUCCESS = 'GET_QUOTATION_SUCCESS';
const GET_QUOTATION_FAILURE = 'GET_QUOTATION_FAILURE';
const GET_QUOTATION_RESET = 'GET_QUOTATION_RESET';

const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

const GET_AREAS_REQUEST = 'GET_AREAS_REQUEST';
const GET_AREAS_SUCCESS = 'GET_AREAS_SUCCESS';
const GET_AREAS_FAILURE = 'GET_AREAS_FAILURE';

const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

const ORDER_AVAILABLE_TIME_REQUEST = 'ORDER_AVAILABLE_TIME_REQUEST';
const ORDER_AVAILABLE_TIME_SUCCESS = 'ORDER_AVAILABLE_TIME_SUCCESS';
const ORDER_AVAILABLE_TIME_FAILURE = 'ORDER_AVAILABLE_TIME_FAILURE';

const ORDER_PICKUP_REQUEST = 'ORDER_PICKUP_REQUEST';
const ORDER_PICKUP_SUCCESS = 'ORDER_PICKUP_SUCCESS';
const ORDER_PICKUP_FAILURE = 'ORDER_PICKUP_FAILURE';

const ORDER_PROCESS_REQUEST = 'ORDER_PROCESS_REQUEST';
const ORDER_PROCESS_SUCCESS = 'ORDER_PROCESS_SUCCESS';
const ORDER_PROCESS_FAILURE = 'ORDER_PROCESS_FAILURE';

const ORDER_COUPON_REQUEST = 'ORDER_COUPON_REQUEST';
const ORDER_COUPON_SUCCESS = 'ORDER_COUPON_SUCCESS';
const ORDER_COUPON_FAILURE = 'ORDER_COUPON_FAILURE';

const ORDER_REMOVE_COUPON_REQUEST = 'ORDER_REMOVE_COUPON_REQUEST';
const ORDER_REMOVE_COUPON_SUCCESS = 'ORDER_REMOVE_COUPON_SUCCESS';
const ORDER_REMOVE_COUPON_FAILURE = 'ORDER_REMOVE_COUPON_FAILURE';

const VOID_PICKUP_REQUEST = 'VOID_PICKUP_REQUEST';
const VOID_PICKUP_FAILURE = 'VOID_PICKUP_FAILURE';
const VOID_PICKUP_SUCCESS = 'VOID_PICKUP_SUCCESS';

const AUTO_SAVE_REQUEST = 'AUTO_SAVE_REQUEST';
const AUTO_SAVE_SUCCESS = 'AUTO_SAVE_SUCCESS';
const AUTO_SAVE_FAILURE = 'AUTO_SAVE_FAILURE';

const GET_AUTO_SAVE_REQUEST = 'GET_AUTO_SAVE_REQUEST';
const GET_AUTO_SAVE_SUCCESS = 'GET_AUTO_SAVE_SUCCESS';
const GET_AUTO_SAVE_FAILURE = 'GET_AUTO_SAVE_FAILURE';

const DUPLICATE_SHIPMENT_REQUEST = 'DUPLICATE_SHIPMENT_REQUEST';
const DUPLICATE_SHIPMENT_SUCCESS = 'DUPLICATE_SHIPMENT_SUCCESS';
const DUPLICATE_SHIPMENT_FAILURE = 'DUPLICATE_SHIPMENT_FAILURE';

const CONFIRM_ADJUSTMENT_REQUEST = 'CONFIRM_ADJUSTMENT_REQUEST';
const CONFIRM_ADJUSTMENT_SUCCESS = 'CONFIRM_ADJUSTMENT_SUCCESS';
const CONFIRM_ADJUSTMENT_FAILURE = 'CONFIRM_ADJUSTMENT_FAILURE';

const GET_TRACKING_REQUEST = 'GET_TRACKING_REQUEST';
const GET_TRACKING_SUCCESS = 'GET_TRACKING_SUCCESS';
const GET_TRACKING_FAILURE = 'GET_TRACKING_FAILURE';

const GET_POSTS_REQUEST = 'GET_POSTS_REQUEST';
const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
const GET_POSTS_FAILURE = 'GET_POSTS_FAILURE';

const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE';

export const getQuotationRequest = params => ({
  type: GET_QUOTATION_REQUEST,
  ...params
});

export const getCountriesRequest = params => ({
  type: GET_COUNTRIES_REQUEST,
  ...params
});

export const getCategoriesRequest = params => ({
  type: GET_CATEGORIES_REQUEST,
  ...params
});

export const getAreasRequest = params => ({
  type: GET_AREAS_REQUEST,
  ...params
});

export const createOrderRequest = params => ({
  type: CREATE_ORDER_REQUEST,
  ...params
});

export const orderAvailableTimeRequest = params => ({
  type: ORDER_AVAILABLE_TIME_REQUEST,
  ...params
});

export const orderPickupRequest = params => ({
  type: ORDER_PICKUP_REQUEST,
  ...params
});

export const orderProcessRequest = params => ({
  type: ORDER_PROCESS_REQUEST,
  ...params
});

export const orderCouponRequest = params => ({
  type: ORDER_COUPON_REQUEST,
  ...params
});

export const orderRemoveCouponRequest = params => ({
  type: ORDER_REMOVE_COUPON_REQUEST,
  ...params
});

export const voidPickupRequest = params => ({
  type: VOID_PICKUP_REQUEST,
  ...params
});

export const autoSaveRequest = params => ({
  type: AUTO_SAVE_REQUEST,
  ...params
});

export const getAutoSaveRequest = params => ({
  type: GET_AUTO_SAVE_REQUEST,
  ...params
});

export const duplicateShipmentRequest = params => ({
  type: DUPLICATE_SHIPMENT_REQUEST,
  ...params
});

export const confirmAdjustmentRequest = params => ({
  type: CONFIRM_ADJUSTMENT_REQUEST,
  ...params
});

export const getTrackingRequest = params => ({
  type: GET_TRACKING_REQUEST,
  ...params
});

export const getPostsRequest = params => ({
  type: GET_POSTS_REQUEST,
  ...params
});

export const getOrderRequest = params => ({
  type: GET_ORDER_REQUEST,
  ...params
});

function* getQuotation(action) {
  const { origin, destination, boxData, reset } = action;

  if (reset) {
    yield put({ type: GET_QUOTATION_RESET });
  } else {
    const { totalWeight, totalVolumeWeight, boxes } = boxData;

    const dataLayerVariable = {
      fromCountry: origin,
      toCountry: destination,
      totalWeight,
      totalVolumeWeight,
      boxes
    };

    window.dataLayer.push({
      event: 'Get Quotation',
      ecommerce: undefined,
      getQuotation: JSON.stringify(dataLayerVariable)
    });

    var options = {
      method: 'POST',
      uri: process.env.REACT_APP_BASE_URL + '/quotations',
      body: {
        fromCountry: origin,
        toCountry: destination,
        totalWeight,
        boxes
      },
      json: true
    };

    try {
      const data = yield rp(options);
      let rates = orderBy(data.data, 'totalRate', 'asc');

      if (data.success && rates.length) {
        forEach(rates, r => {
          dataLayerVariable[r.service] =
            r?.naturalAmount?.totalRate || r?.totalRate;
        });

        const products = [];

        for (let i = 0; i < rates.length; i++) {
          products.push({
            id: `${origin}-${destination}`,
            name: `${origin}-${destination}`,
            price: rates[i]?.naturalAmount?.totalRate || rates[i]?.totalRate,
            brand: rates[i].service,
            category: helpers.getWeightCategory(boxData.totalWeight),
            list: 'Search Results',
            position: i + 1
          });
        }

        window.dataLayer.push({
          event: 'Show Quotation',
          ecommerce: undefined,
          showQuotation: JSON.stringify(dataLayerVariable)
        });

        window.dataLayer.push({
          event: 'Service Impression',
          ecommerce: {
            currencyCode: 'HKD',
            impressions: products
          }
        });

        yield put({ type: GET_QUOTATION_SUCCESS, rates: rates });
      } else {
        yield put({ type: GET_QUOTATION_FAILURE });
        helpers.message.error(
          window.t('error_code.quotation-fail'),
          'quotation'
        );
      }
    } catch (e) {
      console.error(e);
      yield put({ type: GET_QUOTATION_FAILURE });
      helpers.message.error(
        window.t('error_code.quotation-error'),
        'quotation'
      );
    }
  }
}

function* getCountries(action) {
  window.dataLayer.push({
    event: 'Get Countries',
    ecommerce: undefined
  });

  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/countries',
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      const countries = data.data.resources;

      yield put({ type: GET_COUNTRIES_SUCCESS, countries: countries });
    } else {
      yield put({ type: GET_COUNTRIES_FAILURE, countries: countriesData });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_COUNTRIES_FAILURE, countries: countriesData });
  }
}

function* getCategories(action) {
  window.dataLayer.push({
    event: 'Get Categories',
    ecommerce: undefined
  });

  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/categories',
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      const categories = data.data.resources;

      yield put({ type: GET_CATEGORIES_SUCCESS, categories: categories });
    } else {
      yield put({ type: GET_CATEGORIES_FAILURE, categories: categoriesData });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_CATEGORIES_FAILURE, categories: categoriesData });
  }
}

function* getAreas(action) {
  window.dataLayer.push({
    event: 'Get Areas',
    ecommerce: undefined
  });

  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/areas/HK',
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      const areas = data.data.resources;

      yield put({ type: GET_AREAS_SUCCESS, areas: areas });
    } else {
      yield put({ type: GET_AREAS_FAILURE, areas: areasData });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_AREAS_FAILURE, areas: areasData });
  }
}

function* createOrder(action) {
  let {
    origin,
    destination,
    carrier,
    service,
    boxData,
    itemsData,
    itemType,
    isDdp,
    fromAddress,
    toAddress
  } = action;

  const { totalWeight, boxes } = boxData;

  fromAddress = { country: origin, ...fromAddress };
  toAddress = { country: destination, ...toAddress };

  fromAddress.street1 = helpers.mergeAddressStreet1(
    fromAddress.unit,
    fromAddress.street1
  );
  toAddress.street1 = helpers.mergeAddressStreet1(
    toAddress.unit,
    toAddress.street1
  );

  // To support shipping small non-doc items:
  // only ship as document when
  // - it is single item
  // - it is declared as "Document"
  // - it is small x + y + z ≤ 57
  //https://www.sship.xyz/t/need-urgent-fix-error-create-shipment-fail-document-type-only-support-category-document/321/4
  const docTypeShipmentConditions = [boxes.length === 1];

  const isDelaredAsDocument = '' + itemsData[0].mainCategory === '119';
  docTypeShipmentConditions.push(isDelaredAsDocument);

  const { width, height, length } = boxes[0];
  const isWithinDocDimension =
    Number(width) + Number(height) + Number(length) <= 57;
  docTypeShipmentConditions.push(isWithinDocDimension);

  const payload = {
    fromCountry: origin,
    toCountry: destination,
    fromAddress,
    toAddress,
    carrier,
    service,
    itemsData,
    itemType,
    isDdp,
    totalWeight,
    boxes,
    shipmentType: every(docTypeShipmentConditions) ? 'document' : 'parcel'
  };

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/orders',
    body: payload,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: CREATE_ORDER_SUCCESS,
        orderCreatedAt: data.data.createdAt,
        shipmentData: data.data.shipments[0],
        orderRef: data.data.ref
      });
    } else {
      yield put({ type: CREATE_ORDER_FAILURE });

      helpers.message.error(
        {
          message:
            window.t(`error_code.${data.code}`) !== `error_code.${data.code}`
              ? window.t(`error_code.${data.code}`)
              : data.message, // show upstream error from courier
          code: data.code
        },
        'address'
      );
    }
  } catch (e) {
    console.error(e);
    yield put({ type: CREATE_ORDER_FAILURE });
    helpers.message.error(window.t('error_code.shipment-fail'), 'address');
  }
}

function* orderAvailableTime(action) {
  let { orderRef } = action;
  var options = {
    method: 'GET',
    uri:
      process.env.REACT_APP_BASE_URL +
      `/orders/${orderRef}/available-pickup-time`,
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: ORDER_AVAILABLE_TIME_SUCCESS,
        availableData: data.data
      });
    } else {
      yield put({ type: ORDER_AVAILABLE_TIME_FAILURE });

      helpers.message.error(
        {
          message:
            window.t(`error_code.${data.code}`) !== `error_code.${data.code}`
              ? window.t(`error_code.${data.code}`)
              : window.t('error_code.shipment-fail'),
          code: data.code
        },
        'address'
      );
    }
  } catch (e) {
    console.error(e);
    yield put({ type: ORDER_AVAILABLE_TIME_FAILURE });
    helpers.message.error(window.t('error_code.shipment-fail'), 'pickup');
  }
}

function* orderPickup(action) {
  let { orderRef, dateForm } = action;
  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + `/orders/${orderRef}/pickup`,
    body: {
      selfPickup: dateForm.selfPickup,
      date: dateForm.pickupDate,
      from: dateForm.minPickupTime,
      to: dateForm.maxPickupTime
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: ORDER_PICKUP_SUCCESS,
        shipmentData: data.data.shipments[0],
        pickupData: data.data.pickup,
        paperlessImageUrl: data.data.paperlessImageUrl,
        coupon: data.data.coupon,
        discount: data.data.discount
      });
    } else {
      yield put({ type: ORDER_PICKUP_FAILURE });

      let message;

      if (data.code === '4031') {
        message = window.t('error_code.payment-4020');
      } else if (
        window.t(`error_code.${data.code}`) !== `error_code.${data.code}`
      ) {
        message = window.t(`error_code.${data.code}`);
      } else {
        message = window.t('error_code.shipment-fail');
      }

      helpers.message.error(
        {
          message,
          code: data.code
        },
        'pickup'
      );
    }
  } catch (e) {
    console.error(e);
    yield put({ type: ORDER_PICKUP_FAILURE });
    helpers.message.error(window.t('error_code.shipment-fail'), 'pickup');
  }
}
function* orderProcess(action) {
  const { orderRef, token, slug, preRequest, preRequestError } = action;

  if (preRequestError) {
    yield put({ type: ORDER_PROCESS_FAILURE });
  } else if (!preRequest) {
    const options = {
      method: 'POST',
      uri: `${process.env.REACT_APP_BASE_URL}/orders/${orderRef}/process`,
      form: {
        token,
        slug
      },
      json: true
    };

    try {
      const data = yield rp(options);

      if (data.success) {
        yield put({
          type: ORDER_PROCESS_SUCCESS,
          shipmentData: data.data.transaction.shipments[0],
          orderCreatedAt: data.data.transaction.createdAt,
          pickupNumber: data.data.transaction.pickup.pickupNumber,
          ref: data.data.transaction.ref,
          discount: data.data.transaction.discount,
          paymentMethodData: data.data.paymentMethod,
          paymentStatus: data.data.transaction.paymentStatus
        });
      } else {
        let errorMessage;
        switch (data.code) {
          case '4031':
          case '1005':
          case '3002':
          case '3005':
          case '3006':
          case '1113':
            errorMessage = window.t(`error_code.payment-${data.code}`);
            break;
          case '3000':
            errorMessage = window.t('error_code.payment-fail');
            break;
          default:
            errorMessage = window.t('error_code.payment-error');
        }

        helpers.message.error(errorMessage, 'payment');

        window.dataLayer.push({
          event: 'Process Order Error',
          code: data.code
        });

        yield put({ type: ORDER_PROCESS_FAILURE });
      }
    } catch (e) {
      helpers.message.error(window.t('error_code.payment-error'), 'payment');
      console.error(e);
      yield put({ type: ORDER_PROCESS_FAILURE });
    }
  }
}

function* orderCoupon(action) {
  const { orderRef, code } = action;
  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${orderRef}/coupon`,
    form: {
      coupon: code
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: ORDER_COUPON_SUCCESS,
        coupon: data.data.coupon,
        discount: data.data.discount
      });
    } else {
      window.dataLayer.push({
        event: 'Order Coupon Error'
      });

      if (data.code === '4031') {
        helpers.message.error(window.t('error_code.payment-4020'), 'payment');
      }
      yield put({ type: ORDER_COUPON_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: ORDER_COUPON_FAILURE });
  }
}

function* orderRemoveCoupon(action) {
  const { orderRef, code } = action;
  const options = {
    method: 'DELETE',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${orderRef}/coupon`,
    form: {
      coupon: code
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: ORDER_REMOVE_COUPON_SUCCESS,
        coupon: data.data.coupon,
        discount: data.data.discount
      });
    } else {
      window.dataLayer.push({
        event: 'Order Remove Coupon'
      });

      if (data.code === '4031') {
        helpers.message.error(window.t('error_code.payment-4020'), 'payment');
      }
      yield put({ type: ORDER_REMOVE_COUPON_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: ORDER_REMOVE_COUPON_FAILURE });
  }
}

function* voidPickup(action) {
  const { orderRef } = action;
  const options = {
    method: 'DELETE',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${orderRef}/pickup`,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: VOID_PICKUP_SUCCESS
      });
    } else {
      window.dataLayer.push({
        event: 'Void Pickup Error'
      });

      if (data.code === '4031') {
        helpers.message.error(window.t('error_code.payment-4020'), 'payment');
      }
      yield put({ type: VOID_PICKUP_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: VOID_PICKUP_FAILURE });
  }
}

function* autoSave(action) {
  let {
    fromCountry,
    toCountry,
    itemsData,
    itemType,
    fromAddress,
    toAddress
  } = action;

  fromAddress = { fromCountry, ...fromAddress };
  toAddress = { toCountry, ...toAddress };

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/shipments/auto-save',
    body: {
      itemsData,
      itemType,
      fromAddress,
      toAddress
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: AUTO_SAVE_SUCCESS
      });
    } else {
      yield put({ type: AUTO_SAVE_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: AUTO_SAVE_FAILURE });
  }
}

function* getAutoSave(action) {
  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/shipments/auto-save',
    json: true,
    authorization: false
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const itemTypeList = [
        'commercial_use',
        'sample_use',
        'return_goods',
        'personal_use'
      ];
      const { user } = helpers.getJwt();

      if (indexOf(itemTypeList, data.data.itemType) === -1) {
        data.data.itemType =
          user.userType === 'business' ? 'commercial_use' : 'personal_use';
      }
      let formData = data.data;
      yield put({
        type: GET_AUTO_SAVE_SUCCESS,
        recoverFormData: formData
      });
    } else {
      yield put({ type: GET_AUTO_SAVE_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_AUTO_SAVE_FAILURE });
  }
}

function* duplicateShipment(action) {
  const { shipmentRef } = action;

  var options = {
    method: 'POST',
    uri:
      process.env.REACT_APP_BASE_URL +
      '/shipments/' +
      shipmentRef +
      '/duplicate',
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: DUPLICATE_SHIPMENT_SUCCESS
      });
    } else {
      yield put({ type: DUPLICATE_SHIPMENT_FAILURE });
      helpers.message.error(
        window.t('error_code.duplicate-shipment-fail'),
        'shipment'
      );
    }
  } catch (e) {
    console.error(e);
    yield put({ type: DUPLICATE_SHIPMENT_FAILURE });
    helpers.message.error(
      window.t('error_code.duplicate-shipment-fail'),
      'shipment'
    );
  }
}

function* confirmAdjustment(action) {
  const { shipmentRef, confirm, transactionRef } = action;

  var options = {
    method: 'POST',
    uri:
      process.env.REACT_APP_BASE_URL +
      '/orders/' +
      transactionRef +
      '/confirm-adjustment',
    body: { shipmentRef, confirm },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: CONFIRM_ADJUSTMENT_SUCCESS
      });
    } else {
      yield put({ type: CONFIRM_ADJUSTMENT_FAILURE });
      let errorMessage;
      switch (data.code) {
        case '4031':
        case '1005':
        case '3002':
        case '3005':
        case '3006':
        case '1113':
          errorMessage = window.t(`error_code.payment-${data.code}`);
          break;
        case '3000':
          errorMessage = window.t('error_code.payment-fail');
          break;
        default:
          errorMessage = window.t('error_code.payment-error');
      }

      helpers.message.error(errorMessage, 'payment');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: CONFIRM_ADJUSTMENT_FAILURE });
    helpers.message.error(
      window.t('error_code.confirm-adjustment-fail'),
      'shipment'
    );
  }
}

function* getTracking(action) {
  const { trackingNumber } = action;
  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/t/' + trackingNumber,
    json: true,
    authorization: false
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: GET_TRACKING_SUCCESS,
        shipment: data.data
      });
    } else {
      helpers.message.error(window.t('error_code.tracking-error'), 'tracking');
      yield put({ type: GET_TRACKING_FAILURE });
    }
  } catch (e) {
    console.error(e);
    helpers.message.error(window.t('error_code.tracking-error'), 'tracking');
    yield put({ type: GET_TRACKING_FAILURE });
  }
}

function* getPosts(action) {
  var options = {
    method: 'GET',
    uri: process.env.REACT_APP_BASE_URL + '/posts',
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      const posts = data.data.resources;

      yield put({ type: GET_POSTS_SUCCESS, posts });
    } else {
      yield put({ type: GET_POSTS_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_POSTS_FAILURE });
  }
}

function* getOrder(action) {
  const { orderRef } = action;

  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${orderRef}`,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      yield put({
        type: GET_ORDER_SUCCESS,
        paymentStatus: data.data.paymentStatus,
        orderCreatedAt: data.data.createdAt,
        transactionStatus: data.data.status,
        pickupData: data.data.pickup,
        shipmentData: data.data.shipments[0]
      });
    } else {
      yield put({ type: GET_ORDER_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_ORDER_FAILURE });
  }
}

function* saga() {
  yield takeLatest(GET_QUOTATION_REQUEST, getQuotation);
  yield takeLatest(GET_COUNTRIES_REQUEST, getCountries);
  yield takeLatest(GET_CATEGORIES_REQUEST, getCategories);
  yield takeLatest(GET_AREAS_REQUEST, getAreas);
  yield takeLatest(CREATE_ORDER_REQUEST, createOrder);
  yield takeLatest(ORDER_AVAILABLE_TIME_REQUEST, orderAvailableTime);
  yield takeLatest(ORDER_PICKUP_REQUEST, orderPickup);
  yield takeLatest(ORDER_PROCESS_REQUEST, orderProcess);
  yield takeLatest(ORDER_COUPON_REQUEST, orderCoupon);
  yield takeLatest(ORDER_REMOVE_COUPON_REQUEST, orderRemoveCoupon);
  yield takeLatest(VOID_PICKUP_REQUEST, voidPickup);
  yield takeLatest(AUTO_SAVE_REQUEST, autoSave);
  yield takeLatest(GET_AUTO_SAVE_REQUEST, getAutoSave);
  yield takeLatest(DUPLICATE_SHIPMENT_REQUEST, duplicateShipment);
  yield takeLatest(CONFIRM_ADJUSTMENT_REQUEST, confirmAdjustment);
  yield takeLatest(GET_TRACKING_REQUEST, getTracking);
  yield takeLatest(GET_POSTS_REQUEST, getPosts);
  yield takeLatest(GET_ORDER_REQUEST, getOrder);
}

const reducer = (state = {}, action) => {
  const { props } = action;
  switch (action.type) {
    case SET_REDUX_STATE:
      return {
        ...state,
        ...props.shipments
      };
    case GET_QUOTATION_REQUEST:
      return {
        ...state,
        loading: true,
        showRates: false
      };
    case GET_QUOTATION_SUCCESS:
      return {
        ...state,
        loading: false,
        showRates: true,
        rates: action.rates
      };
    case GET_QUOTATION_FAILURE:
      return {
        ...state,
        loading: false
      };
    case GET_QUOTATION_RESET:
      return {
        ...state,
        loading: false,
        showRates: false
      };
    case GET_COUNTRIES_REQUEST:
      return {
        ...state
      };
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.countries
      };
    case GET_COUNTRIES_FAILURE:
      return {
        ...state,
        countries: action.countries
      };
    case GET_CATEGORIES_REQUEST:
      return {
        ...state
      };
    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.categories
      };
    case GET_CATEGORIES_FAILURE:
      return {
        ...state,
        categories: action.categories
      };
    case GET_AREAS_REQUEST:
      return {
        ...state
      };
    case GET_AREAS_SUCCESS:
      return {
        ...state,
        areas: action.areas
      };
    case GET_AREAS_FAILURE:
      return {
        ...state,
        areas: action.areas
      };
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        orderSuccess: false,
        loading: true
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        orderSuccess: true,
        loading: false,
        orderCreatedAt: action.orderCreatedAt,
        shipmentData: action.shipmentData,
        orderRef: action.orderRef
      };
    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        orderSuccess: false,
        loading: false
      };
    case ORDER_AVAILABLE_TIME_REQUEST:
      return {
        ...state,
        availableSuccess: false,
        loading: true
      };
    case ORDER_AVAILABLE_TIME_SUCCESS:
      return {
        ...state,
        availableSuccess: true,
        loading: false,
        availableData: action.availableData
      };
    case ORDER_AVAILABLE_TIME_FAILURE:
      return {
        ...state,
        availableSuccess: false,
        loading: false
      };
    case ORDER_PICKUP_REQUEST:
      return {
        ...state,
        loading: true,
        pickupSuccess: false
      };
    case ORDER_PICKUP_SUCCESS:
      return {
        ...state,
        pickupSuccess: true,
        loading: false,
        pickupData: action.pickupData,
        shipmentData: action.shipmentData,
        paperlessImageUrl: action.paperlessImageUrl,
        coupon: action.coupon,
        discount: action.discount
      };
    case ORDER_PICKUP_FAILURE:
      return {
        ...state,
        loading: false,
        pickupSuccess: false
      };
    case ORDER_PROCESS_REQUEST:
      return {
        ...state,
        loading: true,
        orderProcessPorcessing: true,
        paymentSuccess: false
      };
    case ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        paymentSuccess: true,
        loading: false,
        orderCreatedAt: action.orderCreatedAt,
        pickupNumber: action.pickupNumber,
        orderRef: action.ref,
        discount: action.discount,
        paymentMethodData: action.paymentMethodData,
        paymentStatus: action.paymentStatus,
        orderProcessPorcessing: false
      };
    case ORDER_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        paymentSuccess: false,
        orderProcessPorcessing: false
      };
    case ORDER_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
        couponSuccess: false
      };
    case ORDER_COUPON_SUCCESS:
      return {
        ...state,
        couponSuccess: true,
        loading: false,
        coupon: action.coupon,
        discount: action.discount
      };
    case ORDER_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        couponSuccess: false
      };
    case ORDER_REMOVE_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
        couponRemoveSuccess: false
      };
    case ORDER_REMOVE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupon: action.coupon,
        discount: action.discount,
        couponRemoveSuccess: true
      };
    case ORDER_REMOVE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        couponRemoveSuccess: false
      };
    case VOID_PICKUP_REQUEST:
      return {
        ...state,
        loading: true
      };
    case VOID_PICKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        pickupData: {},
        pickupSuccess: true
      };
    case VOID_PICKUP_FAILURE:
      return {
        ...state,
        loading: false
      };
    case AUTO_SAVE_REQUEST:
      return {
        ...state
      };
    case AUTO_SAVE_SUCCESS:
      return {
        ...state
      };
    case AUTO_SAVE_FAILURE:
      return {
        ...state
      };
    case GET_AUTO_SAVE_REQUEST:
      return {
        ...state,
        getAutoSaveFinished: false,
        recoverFormData: false
      };
    case GET_AUTO_SAVE_SUCCESS:
      return {
        ...state,
        getAutoSaveFinished: true,
        recoverFormData: action.recoverFormData
      };
    case GET_AUTO_SAVE_FAILURE:
      return {
        ...state,
        getAutoSaveFinished: true,
        recoverFormData: false
      };
    case DUPLICATE_SHIPMENT_REQUEST:
      return {
        ...state,
        loading: true,
        duplicateShipmentSuccess: false
      };
    case DUPLICATE_SHIPMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        duplicateShipmentSuccess: true
      };
    case DUPLICATE_SHIPMENT_FAILURE:
      return {
        ...state,
        loading: false,
        duplicateShipmentSuccess: false
      };
    case CONFIRM_ADJUSTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        confirmAdjustmentSuccess: false
      };
    case CONFIRM_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        confirmAdjustmentSuccess: true
      };
    case CONFIRM_ADJUSTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        confirmAdjustmentSuccess: false
      };
    case GET_TRACKING_REQUEST:
      return {
        ...state,
        trackingLoading: false,
        getTrackingSuccess: false
      };
    case GET_TRACKING_SUCCESS:
      return {
        ...state,
        trackingLoading: false,
        shipment: action.shipment,
        getTrackingSuccess: true
      };
    case GET_TRACKING_FAILURE:
      return {
        ...state,
        trackingLoading: false,
        getTrackingSuccess: true
      };
    case GET_POSTS_REQUEST:
      return {
        ...state,
        posts: false
      };
    case GET_POSTS_SUCCESS:
      return {
        ...state,
        posts: action.posts
      };
    case GET_POSTS_FAILURE:
      return {
        ...state,
        posts: false
      };
    case GET_ORDER_REQUEST:
      return {
        ...state,
        getOrderSuccess: false
      };
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        paymentMethodData: action.paymentMethodData,
        paymentStatus: action.paymentStatus,
        orderCreatedAt: action.orderCreatedAt,
        transactionStatus: action.transactionStatus,
        pickupData: action.pickupData,
        shipmentData: action.shipmentData,
        getOrderSuccess: true
      };
    case GET_ORDER_FAILURE:
      return {
        ...state,
        getOrderSuccess: false
      };
    default:
      return state;
  }
};

export default {
  saga,
  reducer
};
